import { render } from "./TabConfigLanguages.vue?vue&type=template&id=16a57052"
import script from "./TabConfigLanguages.vue?vue&type=script&lang=js"
export * from "./TabConfigLanguages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__